import React from 'react'
import {
    Chart as CharJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Tooltip,
    Legend,
    plugins
} from 'chart.js'
import { Line } from 'react-chartjs-2'

CharJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Tooltip,
    Legend
)

const ComparisonChart = ({ monthlyData }) => {
    const data = {
        labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        datasets: [
            {
                label: 'Warm Lead',
                data: monthlyData.warmLeads,
                borderColor: '#0073a5',
                backgroundColor: '#0073a5',
                borderWidth: 1.5,
                tension: 0,
                fill: false, 
                pointRadius: 2,
                pointHoverRadius: 7
            },
            {
                label: 'Cold Lead',
                data: monthlyData.coldLeads,
                borderColor: '#00d0dc',
                backgroundColor: '#00d0dc',
                borderWidth: 1.5,
                tension: 0,
                fill: false, 
                pointRadius: 2,
                pointHoverRadius: 7
            }
        ]
    }

    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
                labels: {
                    boxWidth: 12,
                    boxHeight: 12, 
                    usePointStyle: true,
                    pointStyle: 'rect',
                    font: { size: 12 }
                }
            },
            tooltip: {
                mode: 'index',
                intersect: false
            }
        },
        scales: {
            y: {
                beginAtZero: true,
                ticks: {
                    stepSize: 10
                },
                grid: {
                    display: true
                }
            },
            x: {
                grid: {
                    display: true
                }
            }
        }
    }
    return <Line data={data} options={options} />
}

export default ComparisonChart